module.exports = __webpack_public_path__ + "doc-lock.png?f49145c6db04d899220cef31bd4deb35";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/attachment-format/doc-lock.png
// module id = 40
// module chunks = 0